// extracted by mini-css-extract-plugin
export var cardHeader = "_hm-1";
export var contentCard = "_hm-0";
export var headerActions = "_hm-3";
export var reorderHandle = "_hm-5";
export var titleArea = "_hm-2";
export var titleAreaWithHandle = "_hm-4";